<template>
  <div :class="$style.base">
    <div :class="$style.title">
      <BaseHeading
        size="xl"
        v-test="'previewTitle'"
      >
        {{ subject ? subject : $t('marketing.email.preview.subject_default') }}
      </BaseHeading>
    </div>

    <div
      :class="[
        $style.htmlStyle,
        {
          [$style.isSmall]: $screen === 's'
        }
      ]"
      v-html="message ? message : $t('marketing.email.preview.content_default')"
      v-test="'previewContent'"
    />
  </div>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { useMarketingStore } from '../../../store';

const { subject, message } = storeToRefs(useMarketingStore());
</script>

<style
  lang="scss"
  module
>
.base {
  align-self: flex-start;
  margin-bottom: $spacing * 2;
}

.title {
  margin-bottom: $spacing;
}

.htmlStyle {
  a {
    color: #06c;
  }
  &.isSmall {
    img {
      width: 100%;
    }
  }

  img {
    max-width: 100%;
  }
}
</style>
